import React from 'react';
import { Box } from '@mui/material';
import ClientServiceOrdersDashboard from '../../components/administration/serviceOrders/ClientServiceOrdersDashboard';

const ClienteOrdenServicioPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <ClientServiceOrdersDashboard
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de cliente ordenes de servicio:', newOrder);
                }}
            />
        </Box>
    );
};

export default ClienteOrdenServicioPage;
